import axiosInstance from './axiosInstance';

const getKriptonians = (filters = {}) => {
  const { pageNumber, pageSize } = filters;

  return axiosInstance.get('/internal/admin/kriptonian/k2ps', {
    params: {
      per_page: pageSize,
      page: pageNumber,
    },
  });
};

export default getKriptonians;
